import { render, staticRenderFns } from "./SocialMidia.vue?vue&type=template&id=73949022"
import script from "./SocialMidia.vue?vue&type=script&lang=js"
export * from "./SocialMidia.vue?vue&type=script&lang=js"
import style0 from "./SocialMidia.vue?vue&type=style&index=0&id=73949022&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports